import React, { useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
  AiOutlineDashboard,
  AiOutlineUser,
  AiOutlineLogout,
  AiOutlinePaperClip,
  AiFillHdd,
  AiFillAlert,
} from "react-icons/ai";
import { CiLaptop } from "react-icons/ci";
import { MdEvent } from "react-icons/md";
import { FaBlogger, FaFileAlt, FaNewspaper } from "react-icons/fa";
import { BiPodcast } from "react-icons/bi";
import { BsFillEnvelopePaperFill } from "react-icons/bs";
import { Outlet } from "react-router-dom";
import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
const { Sider, Content } = Layout;

const IndustrySidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const navigate = useNavigate();

  return (
    <Layout
    /* onContextMenu={(e) => e.preventDefault()} */
    >
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={300}
        // style={{ backgroundColor: "white" }}

        // trigger={null}
        // collapsible
        // collapsed={collapsed}
        // width={300}
        // style={{
        //   position: "fixed",
        //   height: "100%",
        //   left: 0,
        //   top: 0,
        //   zIndex: 1000,
        // }}
      >
        <div style={{ height: "100%", overflowXY: "auto" }}>
          <div className="logo text-center">
            <p className="text-white   mb-0 float-end fs-4">
              {/* <span className="sm-logo">DC</span> */}
              {/* <span className="lg-logo">My Profile</span> */}
              {React.createElement(
                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                  className: "trigger",
                  onClick: () => setCollapsed(!collapsed),
                }
              )}
            </p>
          </div>
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={[""]}
            onClick={({ key }) => {
              if (key === "signout") {
              } else {
                navigate(key);
              }
            }}
            items={[
              {
                key: "",
                icon: <AiOutlineUser className="fs-4" />,
                label: "My Account",
              },

              // {
              //   key: "",
              //   icon: <FaBusinessTime className="fs-4" />,
              //   label: "post internships / jobs",
              //   children: [
              //     {
              //       key: "postinternships",
              //       icon: <BsFillEnvelopePaperFill className="fs-4" />,
              //       label: "Internships",
              //     },
              //     {
              //       key: "postjobs",
              //       icon: <AiFillHdd className="fs-4" />,
              //       label: "Jobs",
              //     },
              //   ],
              // },

              // {
              //   key: "Advertise With Us",
              //   icon: <FaBusinessTime className="fs-4" />,
              //   label: "List Here",
              //   children: [
              // {
              //   key: "addbusiness",
              //   icon: <BsFillEnvelopePaperFill className="fs-4" />,
              //   label: "List Your Business",
              // },

              {
                key: "sds",
                icon: <BsFillEnvelopePaperFill className="fs-4" />,
                label: "Internships",
                children: [
                  {
                    key: "postinternships",
                    icon: <BsFillEnvelopePaperFill className="fs-4" />,
                    label: "Share Internships With Us",
                  },
                  {
                    key: "studentinternshipapplications",
                    icon: <AiFillHdd className="fs-4" />,
                    label: "Received Applications",
                  },
                ],
              },

              {
                key: "",
                icon: <AiFillHdd className="fs-4" />,
                label: "Jobs",
                children: [
                  {
                    key: "postjobs",
                    icon: <AiFillHdd className="fs-4" />,
                    label: "Share Jobs With Us",
                  },
                  {
                    key: "studentjobpapplications",
                    icon: <BsFillEnvelopePaperFill className="fs-4" />,
                    label: "Received Applications",
                  },
                ],
              },
              // {
              //   key: "Advertise",
              //   icon: <AiFillHdd className="fs-4" />,
              //   label: "Advertise With Us",
              //   children: [
              //     {
              //       key: "industrynews",
              //       icon: <FaNewspaper className="fs-4" />,
              //       label: "Share News",
              //     },
              //     {
              //       key: "industryblogs",
              //       icon: <FaBlogger className="fs-4" />,
              //       label: "Share Blogs",
              //     },
              //     // {
              //     //   key: "industrytalks",
              //     //   icon: <MdEvent className="fs-4" />,
              //     //   label: "Share Talks",
              //     // },
              //     {
              //       key: "addindustryevents",
              //       icon: <MdEvent className="fs-4" />,
              //       label: "Share Events",
              //     },
              //     {
              //       key: "evententries",
              //       icon: <FaFileAlt className="fs-4" />,
              //       label: "Events Registrations",
              //     },
              //     {
              //       key: "industrypodcast",
              //       icon: <BiPodcast className="fs-4" />,
              //       label: "Share Podcasts",
              //     },

              //     // {
              //     //   key: "industrypolls",
              //     //   icon: <AiOutlinePaperClip className="fs-4" />,
              //     //   label: "Share Polls / Survey",
              //     // },

              //     {
              //       key: "industrychallenges",
              //       icon: <FaBlogger className="fs-4" />,
              //       label: "Share Industry Challenges",
              //     },
              //     {
              //       key: "ideasfromstudent",
              //       icon: <FaBlogger className="fs-4" />,
              //       label: "Ideas From Student",
              //     },
              //   ],
              // },

              //   ],
              // },
              {
                key: "industryfeedbacks",
                icon: <AiOutlineDashboard className="fs-4" />,
                label: "Share Feedback",
              },
              {
                key: "industryadvertise",
                icon: <BsFillEnvelopePaperFill className="fs-4" />,
                label: "Share Advertisement Enquiry",
              },
              {
                key: "",
                icon: <AiOutlineUser className="fs-4" />,
                label: "About Us",
              },
              {
                key: "faqs",
                icon: <AiFillAlert className="fs-4" />,
                label: "Get Help From Yuvasarathi",
              },
            ]}
          />{" "}
        </div>
      </Sider>
      <Layout className="site-layout">
        <Content
          style={{
            // margin: "24px 16px",
            padding: 22,
            // minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default IndustrySidebar;

// import React, { useState } from "react";
// import { Layout, Menu } from "antd";
// import { useNavigate } from "react-router-dom";
// import {
//   AiOutlineUser,
//   AiOutlineLogout,
//   AiOutlineDashboard,
// } from "react-icons/ai";

// const { Sider } = Layout;

// const Sidebar = ({ userType }) => {
//   const [collapsed, setCollapsed] = useState(false);
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     // Handle logout logic here
//     // You can clear the user's session or perform other necessary tasks.
//   };

//   // Define menu items based on user type
//   const studentMenuItems = [
//     {
//       key: "profile",
//       icon: <AiOutlineUser className="fs-4" />,
//       label: "Profile (Student)",
//     },
//     {
//       key: "studentDashboard",
//       icon: <AiOutlineDashboard className="fs-4" />,
//       label: "Student Dashboard",
//     },
//     {
//       key: "studentLogout",
//       icon: <AiOutlineLogout className="fs-4" />,
//       label: "Logout",
//     },
//   ];

//   const industryMenuItems = [
//     {
//       key: "profile",
//       icon: <AiOutlineUser className="fs-4" />,
//       label: "Profile (Industry)",
//     },
//     {
//       key: "industryDashboard",
//       icon: <AiOutlineDashboard className="fs-4" />,
//       label: "Industry Dashboard",
//     },
//     {
//       key: "industryLogout",
//       icon: <AiOutlineLogout className="fs-4" />,
//       label: "Logout",
//     },
//   ];

//   const menuItems = userType === "student" ? studentMenuItems : industryMenuItems;

//   return (
//     <Sider trigger={null} collapsible collapsed={collapsed}>
//       {/* Your logo and other sidebar content */}
//       <Menu
//         theme="dark"
//         mode="inline"
//         defaultSelectedKeys={["profile"]}
//         onClick={({ key }) => {
//           if (key === "studentLogout" || key === "industryLogout") {
//             handleLogout();
//           } else {
//             navigate(key);
//           }
//         }}
//       >
//         {menuItems.map((item) => (
//           <Menu.Item key={item.key} icon={item.icon}>
//             {item.label}
//           </Menu.Item>
//         ))}
//       </Menu>
//     </Sider>
//   );
// };

// export default Sidebar;
